import bem from 'utils/bem';

export const block = bem('asset-tile-toggle');
